import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { IonAccordionGroup } from '@ionic/angular';
import { PlatformEnum } from '@panamax/app-state';
import { SubRestrictionsEnum } from '@shared/constants/sub-restrictions-enum';
import { ExceptionResolution, OrderHeader } from '@usf/ngrx-order';
import { Product } from 'src/app/shared/models/product.model';
import {
  ExceptionType,
  getExceptionTitle,
  getExceptionDescription,
} from '../../../pages/order-exceptions/constants/order-exception-type.enum';
import { ResolutionType } from '../../../pages/order-exceptions/constants/resolution-type.enum';
import { EmittedFlippedProductNumber } from '../../../pages/order-exceptions/models/emitted-flipped-product-number.model';
import { EmittedPartialFlag } from '../../../pages/order-exceptions/models/emitted-partial-flag-selection.model';
import { EmittedResolution } from '../../../pages/order-exceptions/models/emitted-resolution.model';
import { EmittedSearchForSubs } from '../../../pages/order-exceptions/models/emitted-search-for-subs.model';

@Component({
  template: '',
})
export class ExceptionSectionBaseComponent implements OnInit, OnChanges {
  @Input() orderExceptionType: ExceptionType;
  @Input() exceptionResolutions: ExceptionResolution[];
  @Input() productMap: Map<number, Product>;
  @Input() searchForSubsMap: Map<number, string>;
  @Input() isExpanded = false;
  @Input() isOffline: boolean;
  @Input() platformEnum: PlatformEnum;
  @Input() orderHeader: OrderHeader;
  @Input() selectedDate: string;
  @Input() isExpandedFirstRow;
  @Input() restrictToOg: string;
  @Input() substitutionsAllowed: string;
  @Input() sellerPrice: any;
  @Input() isPartialExceptionsFlagEnabled: boolean;

  @Output() exceptionResolved = new EventEmitter();
  @Output() isExpandedChanged = new EventEmitter();
  @Output() searchForSubsClicked = new EventEmitter();
  @Output() compareProductsClicked = new EventEmitter();
  @Output() updatePriceEmitter = new EventEmitter<any>();
  @Output() updateDateEmitter = new EventEmitter();
  @Output() partialReserveFlagResolved = new EventEmitter<EmittedPartialFlag>();
  @Output()
  substituteProductFlipped = new EventEmitter<EmittedFlippedProductNumber>();
  @Output() editRowResolved = new EventEmitter<ExceptionResolution>();
  @Output() cancelEditRow = new EventEmitter<ExceptionResolution>();
  @ViewChild('accordionGroup', { static: true })
  accordionGroup: IonAccordionGroup;

  exceptionType = ExceptionType;
  sectionTitle: string;
  exceptionMessage: string;
  masterListRestricted: boolean;
  hideSearchForSubs: boolean;

  ngOnInit() {
    this.sectionTitle = getExceptionTitle[this.orderExceptionType];
    this.exceptionMessage = getExceptionDescription[this.orderExceptionType];
    // Need more user feedback on why this one type is pluralized.
    if (this.sectionTitle === 'Acknowledgement') {
      this.sectionTitle = 'Acknowledgements';
    }
    if (this.sectionTitle === 'Date') {
      this.sectionTitle = 'Invalid Delivery Date';
    }
    this.expandFirstRow();
  }

  ngOnChanges(): void {
    this.hideSearchForSubs =
      this.restrictToOg === SubRestrictionsEnum.MASTER_LIST;
    this.masterListRestricted =
      this.restrictToOg === SubRestrictionsEnum.MASTER_LIST &&
      this.substitutionsAllowed === SubRestrictionsEnum.MASTER_LIST;
  }

  resolveExceptionHandler(resolution: EmittedResolution) {
    this.exceptionResolved.emit(resolution);
  }

  searchForSubsHandler(emittedSearchForSubs: EmittedSearchForSubs) {
    this.searchForSubsClicked.emit(emittedSearchForSubs);
  }

  partialFlagResolveHandler(data: EmittedPartialFlag) {
    this.partialReserveFlagResolved.emit(data);
  }

  flipSubstituteProduct(data: EmittedFlippedProductNumber) {
    this.substituteProductFlipped.emit(data);
  }

  editRowHandler(data: ExceptionResolution) {
    this.editRowResolved.emit(data);
  }

  cancelEditRowHandler(data: ExceptionResolution) {
    this.cancelEditRow.emit(data);
  }

  trackByIndex = (index: number, id: any) => index;

  panelChange = event => {
    this.isExpandedChanged.emit(event);
  };

  updatePriceHandler(model: any) {
    this.updatePriceEmitter.emit(model);
  }

  updateDateHandler(resolution: EmittedResolution) {
    this.updateDateEmitter.emit(resolution);
  }

  compareProductsHandler(exceptionResolution: ExceptionResolution) {
    this.compareProductsClicked.emit(exceptionResolution);
  }

  confirmAll() {
    this.exceptionResolutions.forEach(exceptionResolution => {
      const resolution: EmittedResolution = {
        resolutionType: ResolutionType.ACKNOWLEDGED,
        exceptionResolution,
      };
      this.exceptionResolved.emit(resolution);
    });
  }

  expandFirstRow() {
    const nativeEl = this.accordionGroup;
    if (this.isExpandedFirstRow === true) {
      nativeEl.value = 'firstRow';
    }
  }
}
